import { Badge, Tooltip } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

import { computeCapitalizableProjectClusteringStatus, isNoiseOrNoRootClusterType } from '@neo.tax/asc/utils';
import {
  AscClusterType,
  CapitalizableProjectClusteringOverride,
  TABLE_CELL_PLACEHOLDER,
  useCurrentCompanyOrFail,
} from '@neo.tax/shared';

export type CapitalizableProjectClusteringBadgeInput = {
  capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
  capitalizationStartDate?: Date | string | null;
  capitalizationEndDate?: Date | string | null;
  clusterType?: AscClusterType | null;
  startDate?: Date | string | null;
  // Last activity date — gates clause 2 (a capitalizing project must be recently active to stay a
  // matching target). Sourced from the AscProject fragment; omit/null leaves clause 2 ungated.
  endDate?: Date | string | null;
};

export const CapitalizableProjectClusteringBadgeCell = ({
  project,
}: {
  project: CapitalizableProjectClusteringBadgeInput;
}): ReactElement | null => {
  const company = useCurrentCompanyOrFail();
  if (isNoiseOrNoRootClusterType(project.clusterType)) {
    return (
      <Tooltip text="Matching is not applicable to miscellaneous/ops projects.">
        <span>{TABLE_CELL_PLACEHOLDER}</span>
      </Tooltip>
    );
  }
  const status = computeCapitalizableProjectClusteringStatus(
    project,
    company.syncConfigurationAsc?.clusteringMethod ?? null,
    company.lastCompletedAscSyncPeriodEnd,
  );
  return (
    <Tooltip text={status.reasonText}>
      <Badge colorVariant={status.isActive ? 'green' : 'default'} dot={false} maxWidth={150}>
        {status.isActive ? 'Active' : 'Inactive'}
      </Badge>
    </Tooltip>
  );
};
